import React from "react";

import Grid from "@mui/material/Grid";
import LoadDocumentCmp from "../../../components/thumbnail/loadDocumentCmp";
import {
  AdditionalFieldsInfo,
  DocumentUrl,
} from "../../../models/cartable.model";
import BorderedLayout from "../../../layouts/BorderedLayout";
import { Box, Typography } from "@mui/material";

interface Props {
  otherDocuments: DocumentUrl[];
  additionalFieldsInfo: AdditionalFieldsInfo[];
}
export default function FurtherInfo({
  additionalFieldsInfo,
  otherDocuments,
}: Props) {
  return (
    <>
      {additionalFieldsInfo?.length > 0 && (
        <Box sx={{ height: "fit-content", marginBottom: "20px" }}>
          <BorderedLayout title="اقلام اطلاعات تکمیلی">
            <Grid
              container
              sx={{
                alignItems: "center",
                justifyContent: "start",
                padding: "20px",
              }}
              spacing={3}
            >
              {additionalFieldsInfo?.map((info, index) => (
                <Grid
                  item
                  //   sx={{ width: "100%" }}
                  //   xs={12}
                  //   sm={6}
                  //   md={6}
                  //   lg={4}
                  //   xl={3}
                >
                  <Typography
                    key={index}
                    sx={{
                      fontSize: "1rem",
                      color: "#34495E",
                    }}
                  >
                    <span style={{ color: "#9AAFC4" }}>{info.title}:</span>{" "}
                    {info?.value}
                  </Typography>
                </Grid>
              ))}
            </Grid>
          </BorderedLayout>
        </Box>
      )}
      <Grid container xs={12} spacing={2} columns={{ xs: 2, sm: 8, md: 12 }}>
        {otherDocuments?.map((item: any, index: number) => (
          <Grid item xs={2}>
            <LoadDocumentCmp
              data={item}
              title={true}
              parentPage={"furtherInfo"}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
